import { axiosApi } from "../../../api/dbAxios";

interface IFields {
  decision?: string | null;
  short_summary?: string | null;
  summary?: string | null;
}

export const translateFields = async (fields: IFields, target_lang: string) => {
  const fieldsObject: { [key: string]: string } = {};
  (Object.entries(fields) as [keyof IFields, string | null][]).forEach(
    ([key, value]) => {
      if (value !== "" && value !== null && value !== undefined) {
        fieldsObject[key] = value;
      }
    },
  );

  const body = {
    fields: fieldsObject,
    target_lang,
  };

  try {
    const response = await axiosApi.post(`/translate/`, body);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};
